import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isAdmin, isAuthenticated } from '../../state/auth.state';

export const adminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for auth to initialize (e.g., /users/me check)
  await authService.authReady$;

  if (!isAuthenticated() || !isAdmin()) {
    router.navigate(['/home']);
    return false;
  }

  return true;
};
